import { Banknote, Smartphone, Wallet, CreditCard, Receipt, Landmark } from 'lucide-react'

// UI 02/07: ícone + cor por forma de pagamento (colunas da matriz "Detalhe por venda"
// no Fechamento de Caixa E no modal de fechar caixa do PDV). FONTE ÚNICA — os dois
// lugares importam daqui p/ as cores serem SEMPRE idênticas nos dois temas.
// BUG que originou: usar classes Tailwind de cor deixava 3 colunas iguais no escuro
// (os overrides globais .app-dark colapsam blue/cyan/indigo no MESMO azul) e o slate
// ficava da cor do fundo. FIX: cores INLINE próprias, 9 tons distintos, com par
// claro/escuro escolhido pelo tema — sem depender (nem alterar) o CSS global.
// Casa por substring do nome da forma; ordem importa (crediário/crédito antes do cartão genérico).
export type FormaPaleta = {
  icon: any
  light: { bg: string; text: string; icon: string }
  dark: { bg: string; text: string; icon: string }
}

export function formaVisual(forma: string): FormaPaleta {
  const f = (forma || '').toLowerCase()
  const P = (icon: any, lbg: string, ltext: string, licon: string, dbg: string, dtext: string, dicon: string): FormaPaleta =>
    ({ icon, light: { bg: lbg, text: ltext, icon: licon }, dark: { bg: dbg, text: dtext, icon: dicon } })
  // dinheiro — verde
  if (f.includes('dinheiro') || f.includes('especie') || f.includes('espécie'))
    return P(Banknote,   '#ecfdf5', '#047857', '#10b981',  '#0b2e20', '#6ee7b7', '#34d399')
  // pix — teal. MUDANÇA 09/07: "à vista" é tratada COMO PIX (meio eletrônico, fora da
  // gaveta — ver _FORMAS_GAVETA em caixa_routes.py), então ganha o visual do pix.
  if (f.includes('pix') || f === 'a_vista')
    return P(Smartphone, '#f0fdfa', '#0f766e', '#14b8a6',  '#0a2e2a', '#5eead4', '#2dd4bf')
  // crediário / a prazo — rosa
  if (f.includes('crediar') || f.includes('prazo'))
    return P(Wallet,     '#fff1f2', '#be123c', '#f43f5e',  '#350f18', '#fda4af', '#fb7185')
  // cartão crédito — índigo
  if (f.includes('credito') || f.includes('crédito'))
    return P(CreditCard, '#eef2ff', '#4338ca', '#6366f1',  '#1a1c3d', '#a5b4fc', '#818cf8')
  // cartão débito — azul-céu
  if (f.includes('debito') || f.includes('débito'))
    return P(CreditCard, '#f0f9ff', '#0369a1', '#0ea5e9',  '#0a2a3f', '#7dd3fc', '#38bdf8')
  // cartão (genérico) — violeta
  if (f.includes('cart'))
    return P(CreditCard, '#f5f3ff', '#6d28d9', '#8b5cf6',  '#221545', '#c4b5fd', '#a78bfa')
  // boleto — âmbar
  if (f.includes('boleto'))
    return P(Receipt,    '#fffbeb', '#b45309', '#f59e0b',  '#2e2207', '#fcd34d', '#fbbf24')
  // transferência — azul
  if (f.includes('transf'))
    return P(Landmark,   '#eff6ff', '#1d4ed8', '#3b82f6',  '#10203f', '#93c5fd', '#60a5fa')
  // outros — cinza (bg distinto do fundo do card em ambos os temas)
  return P(Wallet,       '#f8fafc', '#475569', '#94a3b8',  '#2b3242', '#cbd5e1', '#94a3b8')
}
